import React, {Component} from "react";
import {fromJS} from "immutable";
import gql from "graphql-tag";
import {graphql} from "react-apollo";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import AddressInline from "../../../components/AddressInline";
import PaginatorButton from "../../../components/PaginatorButton";
import {longDateFormat} from "../../../lib/DateFormatter";
import {formatSalesOrderStatus, formatStatusForMessage} from "../../../lib/SalesOrderStatus";
import {Link} from "react-router";
import "./NotificationsList.scss";
import StatusTag from "../../../components/StatusTag";


class SalesNotificationsList extends Component {

  render() {
    let {loading, error, salesOrders} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        
    const data = fromJS(salesOrders);

    let items = data.get("entries").map((x) => {
      return <Item key={x.get("orderId")} data={x} />
    }).toList();

    return (
      <div className="SalesNotificationsList NotificationsList">
        {items}
        <PaginatorButton 
          metadata={data.get("metadata")} 
          onNext={this.handleNext.bind(this)}
          />        
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          salesOrders: {
            __typename: prev.salesOrders.__typename,
            metadata: fetchMoreResult.salesOrders.metadata,
            entries: [...prev.salesOrders.entries, ...fetchMoreResult.salesOrders.entries]
          }
        }
      }
    })
  }  

}

const Item = ({data}) => {

  let title = data.get("source") === "subscription" ? "Subscription order" : "Order";

  return (
    <div className="item">
      <div className="body">
        <p>
          <Link to={`/sales/orders/${data.get("orderId")}`}>{title}</Link> for <AddressInline address={data.get("billingAddress")} /> with invoice <strong>#{data.get("invoiceNr")}</strong> and value of <strong>{price(data)}</strong> is <strong>{formatStatusForMessage(data.get("billingStatus"))}</strong>.
          Order received: {longDateFormat(data.get("createdAt"))}
        </p>
        { getTagForStatus(data.get("billingStatus"), formatSalesOrderStatus(data.get("billingStatus"))) }

        <StatusTag color={StatusTag.COLORS.OUTLINE} text={data.get("shopId")} />
      </div>
    </div>
  )

}

function price(data) {
  return `${data.get("total")} ${data.get("currency")}`;
}

function getTagForStatus(status, label) {
  switch(status) {
    case "waiting":
      return <StatusTag color={StatusTag.COLORS.RED} text={label} />
    case "billed":
      return <StatusTag color={StatusTag.COLORS.BLACK} text={label} />

    default:
      return <StatusTag color={StatusTag.COLORS.GREY} text={label} />
  }
}

const QUERY = gql`
  query salesOrders($filter:SalesOrderFilterInput, $pagination:PaginationInput) {
    salesOrders(filter:$filter, pagination: $pagination) {
      entries {
        orderId
        shopId
        total
        currency
        billingStatus
        subscription
        billingAddress {
          name
          addressAddressLine1
          addressAddressLine2
          addressCity
          addressPostcode
          addressStateProvince
          addressCountryName
        }
        source
        invoiceNr
        createdAt
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`

const withQuery = graphql(QUERY, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: {
        billingStatus: "not_paid"
      }
    }
  })
})

export default withQuery(SalesNotificationsList);